import React from 'react';
import { Link } from 'react-router-dom';
import { 
  Home, 
  Users, 
  Calendar, 
  Trophy, 
  ShoppingBag,
  HelpCircle,
  MessageCircle,
  Star,
  X,
  BarChart3,
  Target,
  CheckCircle
} from 'lucide-react';

interface MobileMainNavigationProps {
  isOpen: boolean;
  onClose: () => void;
  userRole?: string;
}

const MobileMainNavigation = ({ isOpen, onClose, userRole }: MobileMainNavigationProps) => {
  if (!isOpen) return null;

  const handleLinkClick = () => {
    onClose();
  };

  const getNavItemsForRole = () => {
    const baseItems = [
      { label: 'Home', href: '/', icon: Home },
      { label: 'BETA', href: '/agent-beta', icon: Star, badge: 'Apply' },
      { label: 'Community', href: '/community', icon: Users },
      { label: 'Events', href: '/events', icon: Calendar },
      { label: 'Tournaments', href: '/tournaments', icon: Trophy },
      { label: 'Teams', href: '/teams', icon: Users },
      { label: 'Lockeroom', href: '/chat', icon: MessageCircle },
      { label: 'Shop', href: '/shop', icon: ShoppingBag, badge: 'Soon' },
      { label: 'Points', href: '/points', icon: Star },
      { label: 'FAQ', href: '/faq', icon: HelpCircle },
      { label: 'Support', href: '/support', icon: HelpCircle },
      { label: 'Contact', href: '/contact', icon: HelpCircle },
    ];

    // Add role-specific items
    if (userRole === 'scorekeeper') {
      baseItems.splice(3, 0, 
        { label: 'Scorekeeper Dashboard', href: '/scorekeeper/dashboard', icon: BarChart3 },
        { label: 'My Assignments', href: '/scorekeeper/assignments', icon: Target }
      );
    }

    return baseItems;
  };

  const mainNavItems = getNavItemsForRole();

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 md:hidden">
      <div className="fixed top-0 left-0 h-full w-80 bg-gray-900 border-r border-gray-700 flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-gray-700">
          <h2 className="text-white text-lg font-semibold">Navigation</h2>
          <button 
            onClick={onClose}
            className="text-gray-400 hover:text-white"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        {/* Navigation Items */}
        <div className="flex-1 overflow-y-auto p-4">
          <nav className="space-y-2">
            {mainNavItems.map((item) => {
              const Icon = item.icon;
              return (
                <Link
                  key={item.href}
                  to={item.href}
                  onClick={handleLinkClick}
                  className="flex items-center justify-between gap-3 p-3 text-gray-300 hover:bg-gray-800 hover:text-white transition-colors rounded-lg"
                >
                  <div className="flex items-center gap-3">
                    <Icon className="h-5 w-5" />
                    <span>{item.label}</span>
                  </div>
                  {item.badge && (
                    <span className="bg-sports-green text-black text-xs px-2 py-1 rounded">
                      {item.badge}
                    </span>
                  )}
                </Link>
              );
            })}
          </nav>
        </div>
      </div>
    </div>
  );
};

export default MobileMainNavigation;